import { BaseInfoModel, BaseTooltipModel } from './removableDentureDetail';
import { environment } from '../../../environments/environment';

export const PatientAgeRange: BaseInfoModel[] = [
    {
        id: 1,
        name: '13-17',
    },
    {
        id: 2,
        name: '18+',
    },
];

export const ClearAlignerType: BaseInfoModel[] = [
    {
        id: 1,
        name: 'Initial',
    },
    {
        id: 2,
        name: 'Refinement',
    },
];

// export const TreatmentOptions: BaseInfoModel[] = [
//     {
//         id: 1,
//         name: 'Upper Esthetic',
//         imagePath: `${treatmentDetailsImagePrefix}/esthetic/upper.svg`,
//     },
//     {
//         id: 2,
//         name: 'Lower Esthetic',
//         imagePath: `${treatmentDetailsImagePrefix}/esthetic/lower.svg`,
//     },
// ];

export const MidlinesImproveId = 1;
const treatmentDetailsImagePrefix = `/assets/images/version-2/clear-aligner`;

export const Midlines: BaseInfoModel[] = [
    {
        id: MidlinesImproveId,
        name: 'Improve',
        imagePath: `${treatmentDetailsImagePrefix}/midlines/improve.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/midlines/improve-dark.svg`,
    },
    {
        id: 2,
        name: 'Maintain',
        imagePath: `${treatmentDetailsImagePrefix}/midlines/maintain.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/midlines/maintain-dark.svg`,
    },
];

export const Overjet: BaseInfoModel[] = [
    {
        id: 1,
        name: 'Improve',
        imagePath: `${treatmentDetailsImagePrefix}/overjet/improve.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/overjet/improve-dark.svg`,
    },
    {
        id: 2,
        name: 'Maintain (May Require IPR)',
        imagePath: `${treatmentDetailsImagePrefix}/overjet/maintain.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/overjet/maintain-dark.svg`,
    },
];

export const Overbite: BaseInfoModel[] = [
    {
        id: 1,
        name: 'Improve',
        imagePath: `${treatmentDetailsImagePrefix}/overbite/improve.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/overbite/improve-dark.svg`,
    },
    {
        id: 2,
        name: 'Maintain',
        imagePath: `${treatmentDetailsImagePrefix}/overbite/maintain.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/overbite/maintain-dark.svg`,
    },
];

export const ToothSizeDiscrepancy: BaseInfoModel[] = [
    {
        id: 1,
        name: 'Leave Spaces Open Distal to Laterals',
        imagePath: `${treatmentDetailsImagePrefix}/size-discrepancy/leave-space-laterals.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/size-discrepancy/leave-space-laterals-dark.svg`,
    },
    {
        id: 2,
        name: 'Leave Spaces Open Distal to Canines',
        imagePath: `${treatmentDetailsImagePrefix}/size-discrepancy/leave-space-canines.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/size-discrepancy/leave-space-canines-dark.svg`,
    },
    {
        id: 3,
        name: 'Close all Spaces',
        imagePath: `${treatmentDetailsImagePrefix}/size-discrepancy/close-all-spaces.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/size-discrepancy/close-all-spaces-dark.svg`,
    },
];

export const AttachmentsTeethToExcludeId = 23;

export const Attachments: BaseInfoModel[] = [
    {
        id: 1,
        name: 'Place Attachments as Needed',
        imagePath: `${treatmentDetailsImagePrefix}/attachments/place-attachments.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/attachments/place-attachments-dark.svg`,
    },
    {
        id: AttachmentsTeethToExcludeId,
        name: 'Select Teeth to Exclude from Attachments',
        imagePath: `${treatmentDetailsImagePrefix}/attachments/select-teeth-exclude.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/attachments/select-teeth-exclude-dark.svg`,
    },
    {
        id: 3,
        name: 'No Attachments',
        imagePath: `${treatmentDetailsImagePrefix}/attachments/no-attachments.svg`,
    },
];

export const IPRTeethToExcludeId = 2;

export const IPR: BaseInfoModel[] = [
    {
        id: 1,
        name: 'IPR as Needed',
        imagePath: `${treatmentDetailsImagePrefix}/ipr/needed.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/ipr/needed-dark.svg`,
    },
    {
        id: IPRTeethToExcludeId,
        name: 'Select Teeth to Exclude from IPR',
        imagePath: `${treatmentDetailsImagePrefix}/ipr/select.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/ipr/select-dark.svg`,
    },
    {
        id: 3,
        name: 'No IPR',
        imagePath: `${treatmentDetailsImagePrefix}/ipr/no-IPR.svg`,
    },
];

export const AnteriorCanineRelationshipRight: BaseInfoModel[] = [
    {
        id: 1,
        name: 'Improve',
        imagePath: `${treatmentDetailsImagePrefix}/anterior/right-improve.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/anterior/right-improve-dark.svg`,
    },
    {
        id: 2,
        name: 'Maintain',
        imagePath: `${treatmentDetailsImagePrefix}/anterior/right-maintain.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/anterior/right-maintain-dark.svg`,
    },
];

export const AnteriorCanineRelationshipLeft: BaseInfoModel[] = [
    {
        id: 1,
        name: 'Improve',
        imagePath: `${treatmentDetailsImagePrefix}/anterior/left-improve.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/anterior/left-improve-dark.svg`,
    },
    {
        id: 2,
        name: 'Maintain',
        imagePath: `${treatmentDetailsImagePrefix}/anterior/left-maintain.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/anterior/left-maintain-dark.svg`,
    },
];

export const ClinicalConditions: BaseInfoModel[] = [
    {
        id: 43,
        name: 'Class I',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/class-i.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/class-i-dark.svg`,
    },
    {
        id: 44,
        name: 'Class II',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/class-ii.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/class-ii-dark.svg`,
    },
    {
        id: 45,
        name: 'Class III',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/class-iii.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/class-iii-dark.svg`,
    },
    {
        id: 46,
        name: 'Crowding',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/crowding.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/crowding-dark.svg`,
    },
    {
        id: 47,
        name: 'Spacing',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/spacing.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/spacing-dark.svg`,
    },
    {
        id: 48,
        name: 'Flared Teeth',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/flared-teeth.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/flared-teeth-dark.svg`,
    },
    {
        id: 49,
        name: 'Uneven Smile',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/uneven-smile.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/uneven-smile-dark.svg`,
    },
    {
        id: 50,
        name: 'Misshapen Teeth',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/misshapen-teeth.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/misshapen-teeth-dark.svg`,
    },
    {
        id: 51,
        name: 'Overjet',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/overjet.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/overjet-dark.svg`,
    },
    {
        id: 52,
        name: 'Deep Bite',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/deep-bite.svg`,
        darkModeImagePath: `${treatmentDetailsImagePrefix}/clinical-condition/deep-bite-dark.svg`,
    },
];

export const ClinicalConditionsOtherId = 56;

export const SmileCorrectClinicalConditions: BaseInfoModel[] = [
    {
        id: 53,
        name: 'Slight Crowding',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/slight-crowding.webp`,
    },
    {
        id: 54,
        name: 'Minor Spacing',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/minor-spacing.webp`,
    },
    {
        id: 55,
        name: 'Slight Rotation',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/slight-rotation.webp`,
    },
    {
        id: ClinicalConditionsOtherId,
        name: 'Other',
        imagePath: `${treatmentDetailsImagePrefix}/clinical-condition/other.webp`,
    },
];

export const TeethNotMoveTooltip: BaseTooltipModel = {
    active: false,
    title: 'general.teethSelection',
    body: {
        sections: [
            {
                description: 'messages.smileCorrectTeethNotMoveTooltip',
            },
        ],
    },
    placement: 'top',
};
